module.exports = "<div class=container> <div class=\"jumbotron mt100\"> <h1 class=text-center>500 Internal server error<p> </p></h1> <p class=text-center>There is a problem with the resource you are looking for and it cannot be displayed.</p> <p class=text-center><a class=\"btn btn-primary\" href=#><i class=\"fa fa-home\"></i> Take Me Home</a></p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./travel-developers-interface/src/main/client/static/content/error500.html
// module id = 3706460768780088
// module chunks = 0 2 3